import React, { FC } from 'react';
import { MultiSelectionEntity } from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { RouterLocation } from '@funtech-int/rival';
import { Picture, createPictureFactory } from '@funtech-int/yango-shared';

import * as CardKit from '../CardKit';

import styles from './_Selection.module.css';

const pictureFactory = createPictureFactory({
    fallback: {
        src: '720x360',
    },
});

interface SelectionProps {
    entity: MultiSelectionEntity;
    location: RouterLocation<any, any>;
    searchParams?: URLSearchParams;
    onShow?: VoidFunction;
    onClick?: VoidFunction;
}

export const Selection: FC<SelectionProps> = ({
    entity,
    location,
    searchParams,
    onShow,
    onClick,
}) => {
    const { img } = pictureFactory({
        fallbackUrl: entity.cover?.toString(),
    });

    return (
        <CardKit.Layout
            location={location}
            searchParams={searchParams}
            onShow={onShow}
            onClick={onClick}
            dataTid="CardSelection"
            withShadow
        >
            <Picture
                className={styles.image}
                alt={entity.title}
                loading="lazy"
                srcSet={img.srcSet}
                src={img.src}
                data-tid="AdaptiveImage"
            />
        </CardKit.Layout>
    );
};
